import React from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';
import { MilestonesStrip } from './components/MilestonesStrip';
import { FeaturedUpdate } from './components/FeaturedUpdate';
import { MapVisor } from './components/MapVisor';
import { EscuelaIntercultural } from './components/EscuelaIntercultural';
import { AcuerdosPNN } from './components/AcuerdosPNN';
import { ColombiaEnMapas } from './components/ColombiaEnMapas';
import { DiplomadosVirtuales } from './components/DiplomadosVirtuales';
import { ImpactNumbers } from './components/ImpactNumbers';
import { NewsGrid } from './components/NewsGrid';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bone text-charcoal font-sans selection:bg-clay selection:text-bone" data-id="element-0">
      <NavBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <MilestonesStrip data-id="element-4" />
        <FeaturedUpdate data-id="element-5" />
        <MapVisor data-id="element-6" />
        <EscuelaIntercultural data-id="element-7" />
        <AcuerdosPNN data-id="element-8" />
        <ColombiaEnMapas data-id="element-9" />
        <DiplomadosVirtuales data-id="element-10" />
        <ImpactNumbers data-id="element-11" />
        <NewsGrid data-id="element-12" />
        <ClosingCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}